import React from "react";
import { Redirect } from "react-router-dom";

const PublicGuard = ({ children, type }) => {
  let token = "";
  let userId = "";

  if (type === "user") {
    token = localStorage.getItem("user.token");
    userId = localStorage.getItem("user.id");
  }else if(type === 'consultant'){
    token = localStorage.getItem("consultant.token");
    userId = localStorage.getItem("consultant.id");
  } else if (type === "candidate") {
    token = localStorage.getItem("candidate.token");
    userId = localStorage.getItem("candidate.id");
  }

  if (token && userId) {
    if (type === "user")
      return <Redirect to="/candidate_dashboard?tab=Application_Received" />;
    if (type === "consultant") return <Redirect to="/consultantdashboard" />;
    if (type === "candidate") return <Redirect to="/careers/home" />;
  }

  return <>{children}</>;
};

export default PublicGuard;
